export const NewRelic = window.NREUM;

export const noticeError = (err, customAttributes = {}) => {
  console.info("noticeError", err, customAttributes);
  NewRelic?.noticeError(err, customAttributes);
};


export const setCustomAttribute = (value, name = 'utm_source', persist=false) => {
  console.info(`Set ${name} to ${value}`);
  NewRelic?.setCustomAttribute(name, value, persist);
};
